/** The Midway-gated desktop download site (`DOWNLOAD_SITE.domain` in infrastructure/lib/config.ts). */
export const DOWNLOAD_APP_URL = 'https://download.amp.music.amazon.dev/'
